import { OrderStatus, OrderStatusCode } from "../../../../../../models/IOrder";
import { ActionButton } from "./styles";
import { useHistory } from "react-router-dom";
import { Modal } from "../../../../../../components/modal";
import { useState } from "react";
import {
	deleteOrder,
	updateOrderStatus,
} from "../../../../../../services/manager/admin/orders.service";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

interface ITableActionButton {
	id: number;
	status: OrderStatus;
	actionPerformedCallback: () => void;
}

type IOrderAction = {
	label: string;
	action: "view" | "update" | "delete";
	status_display?: OrderStatus;
	status_code?: OrderStatusCode;
};

export const TableActionButton: React.FC<ITableActionButton> = ({
	id,
	status,
	actionPerformedCallback,
}) => {
	const history = useHistory();
	const { t: translate } = useTranslation();

	const possibleActions: IOrderAction[] = [
		{
			label: "Visualizar",
			action: "view",
		},
		{
			label: "Excluir",
			action: "delete",
		},
		{
			label: "Mudar status para aberto",
			status_display: "OPEN",
			status_code: 1,
			action: "update",
		},
		{
			label: "Mudar status para processando",
			status_display: "PROCESSING",
			status_code: 2,
			action: "update",
		},
		{
			label: "Mudar status para cancelado",
			status_display: "CANCELED",
			status_code: 3,
			action: "update",
		},
		{
			label: "Mudar status para concluído",
			status_display: "CLOSED",
			status_code: 4,
			action: "update",
		},
	];

	const handleAction = (e: any) => {
		let actionItem = e.value as IOrderAction;

		switch (actionItem.action) {
			case "view":
				history.push(`/manager/order/${id}`);
				break;
			case "delete":
				setShowDeleteConfirmation(true);
				break;
			case "update":
				let prefix = translate("manager.orders.status_update.prefix");
				let postfix = translate("manager.orders.status_update.postfix");
				let status_display = translate(
					`manager.orders.status_update.${actionItem.status_display}`
				);

				updateOrderStatus(id, actionItem.status_code!).then(
					(response) => {
						// ex: Status do pedido 123 alterado para aberto.
						toast.success(
							`${prefix} ${id} ${postfix} ${status_display}.`
						);
						actionPerformedCallback();
					}
				);
				break;
		}
	};

	const handleDeleteConfirmation = () => {
		setShowDeleteConfirmation(false);

		deleteOrder(id).then((response) => {
			toast.success(`Pedido ${id} excluído.`);
			actionPerformedCallback();
		});
	};

	const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
	return (
		<div>
			<ActionButton
				// o status do pedido pode ser alterado para status diferentes do dele
				// quando o status for "concluído" ou "cancelado", ele não pode voltar a um estado anterior, apenas ser excluído ou visualizado
				options={possibleActions.filter(
					(item) =>
						(status === "CLOSED" && !item.status_display) ||
						(status === "CANCELED" && !item.status_display) ||
						(status !== "CLOSED" &&
							status !== "CANCELED" &&
							item.status_display !== status)
				)}
				onChange={handleAction}
				dropdownIcon="pi-ellipsis-h"
			>
				<span>teste</span>
			</ActionButton>
			{/* Confirmação de exclusão */}
			<Modal
				headerTitle="Aviso"
				submitButtonText="Excluir pedido"
				show={showDeleteConfirmation}
				variant="confirm-modal"
				onHide={() => {
					setShowDeleteConfirmation(false);
				}}
				loading={false}
				onSubmit={handleDeleteConfirmation}
			>
				<p>
					Tem certeza que deseja <b>excluir</b> o pedido {id}?
				</p>
				<p>Esta ação não pode ser desfeita.</p>
			</Modal>
		</div>
	);
};
